import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

import { Observable } from 'rxjs/Observable';

import { BaseHttpService } from './base-http.service';
import {FMLayout,FMIssueList, FMGeneralRequestModel, PaginationModel, PagedResult, FMAllRequestsModel, CompanyBuildingUnitView, FMSpecialRequestModel, FMRegisterHazardMaterial, MaterialFile, FMDeliveryRequestModel } from '../models';
import { FMRequestHazardMaterial } from '@app/core';

@Injectable()
export class FMService extends BaseHttpService<any> {

  constructor(private http: HttpClient) {
    super('facilityandmaintenance');
  }

  addNewFMGeneralRequest(formData: FormData): Observable<FMGeneralRequestModel> {
    return this.http
      .post(this.getApiURI() + '/facilityandmaintenance/addFmGeneralRequest', formData, { headers: new HttpHeaders({ 'RequestWithFiles': 'RequestWithFiles' }) })
      .catch(this.handleError)
  }

  addNewFMSpecialRequest(formData: FormData): Observable<any> {
    return this.http
      .post(this.getApiURI() + '/facilityandmaintenance/addFmSpecialRequest', formData, { headers: new HttpHeaders({ 'RequestWithFiles': 'RequestWithFiles' }) })
      .catch(this.handleError)
  }
  registerHazardMaterial(formData: FormData): Observable<any> {
    return this.http
      .post(this.getApiURI() + '/facilityandmaintenance/addHazardMaterial', formData, { headers: new HttpHeaders({ 'RequestWithFiles': 'RequestWithFiles' }) })
      .catch(this.handleError)
  }

  addNewFMHazardDeliveryRequestRequest(formData: FormData): Observable<any> {
    return this.http
      .post(this.getApiURI() + '/facilityandmaintenance/addFmHazardDeliveryRequest', formData, { headers: new HttpHeaders({ 'RequestWithFiles': 'RequestWithFiles' }) })
      .catch(this.handleError)
  }
  addNewFMGeneralDeliveryRequestRequest(formData: FormData): Observable<any> {
    return this.http
      .post(this.getApiURI() + '/facilityandmaintenance/addFmGeneralDeliveryRequest', formData, { headers: new HttpHeaders({ 'RequestWithFiles': 'RequestWithFiles' }) })
      .catch(this.handleError)
  }



  getIssueList(): Observable<FMIssueList[]> {

    console.log('in fun');
    return this.http
      .get(this.getApiURI() + '/facilityandmaintenance/GetFMIssueList')
      .catch(this.handleError)
  }

  GetFMLayout(): Observable<FMLayout[]> {

    return this.http
      .get(this.getApiURI() + '/facilityandmaintenance/GetFMLayout')
      .catch(this.handleError)
  }

  getFMGeneralRequests(model: { paginationModel: PaginationModel, pendingOnly: boolean, requestStatusId: number, requestNo: string, requestId: number }): Observable<PagedResult<FMGeneralRequestModel>> {
    return this.http
      .get(this.getApiURI() + '/facilityandmaintenance/GetFMGeneralRequests' + `?pagingParameters.pageNumber=${model.paginationModel.pageNumber}&pagingParameters.pageSize=${model.paginationModel.pageSize}&pagingParameters.orderBy=${model.paginationModel.orderBy}&pendingOnly=${model.pendingOnly}&requestStatusId=${model.requestStatusId}&requestNo=${model.requestNo}&requestId=${model.requestId}`)
      .catch(this.handleError)
  }
  getDeliveryRequests(model: { paginationModel: PaginationModel, pendingOnly: boolean, requestStatusId: number, requestNo: string, requestId: number }): Observable<PagedResult<FMDeliveryRequestModel>> {
    return this.http
      .get(this.getApiURI() + '/facilityandmaintenance/GetDeliveryRequests' + `?pagingParameters.pageNumber=${model.paginationModel.pageNumber}&pagingParameters.pageSize=${model.paginationModel.pageSize}&pagingParameters.orderBy=${model.paginationModel.orderBy}&pendingOnly=${model.pendingOnly}&requestStatusId=${model.requestStatusId}&requestNo=${model.requestNo}&requestId=${model.requestId}`)
      .catch(this.handleError)
  }

  getFMSpecialRequests(model: { paginationModel: PaginationModel, pendingOnly: boolean, requestStatusId: number, requestNo: string, requestId: number }): Observable<PagedResult<FMSpecialRequestModel>> {
    return this.http
      .get(this.getApiURI() + '/facilityandmaintenance/GetFMSpecialRequests' + `?pagingParameters.pageNumber=${model.paginationModel.pageNumber}&pagingParameters.pageSize=${model.paginationModel.pageSize}&pagingParameters.orderBy=${model.paginationModel.orderBy}&pendingOnly=${model.pendingOnly}&requestStatusId=${model.requestStatusId}&requestNo=${model.requestNo}&requestId=${model.requestId}`)
      .catch(this.handleError)
  }
  getFMAllRequests(model: { paginationModel: PaginationModel, pendingOnly: boolean, requestStatusId: number, requestNo: string, requestId: number }): Observable<PagedResult<FMAllRequestsModel>> {
    return this.http
      .get(this.getApiURI() + '/facilityandmaintenance/GetFMAllRequests' + `?pagingParameters.pageNumber=${model.paginationModel.pageNumber}&pagingParameters.pageSize=${model.paginationModel.pageSize}&pagingParameters.orderBy=${model.paginationModel.orderBy}&pendingOnly=${model.pendingOnly}&requestStatusId=${model.requestStatusId}&requestNo=${model.requestNo}&requestId=${model.requestId}`)
      .catch(this.handleError)
  }
  getFMAllRegisteredHazard(model: { paginationModel: PaginationModel, pendingOnly: boolean, requestStatusId: number, requestNo: string, requestId: number }): Observable<PagedResult<FMRegisterHazardMaterial>> {
    return this.http
      .get(this.getApiURI() + '/facilityandmaintenance/GetRegisteredHazard' + `?pagingParameters.pageNumber=${model.paginationModel.pageNumber}&pagingParameters.pageSize=${model.paginationModel.pageSize}&pagingParameters.orderBy=${model.paginationModel.orderBy}&pendingOnly=${model.pendingOnly}&requestStatusId=${model.requestStatusId}&requestNo=${model.requestNo}&requestId=${model.requestId}`)
      .catch(this.handleError)
  }
  getFMREquestLocation(requestId: number): Observable<CompanyBuildingUnitView[]> {
    return this.http
      .post(this.getApiURI() + '/facilityandmaintenance/GetLocations', JSON.stringify({ requestId }))
      .catch(this.handleError)
  }
  approveGeneralRequestByTenant(requestId: number, PO: string): Observable<any> {
    return this.httpClient
      .put(this.getApiURI() + `/facilityandmaintenance/${requestId}/approve-fm-tenant`, {PO:PO})
      .catch(this.handleError)
  }
  approveRegisterHazardMaterialRequestByTenant(requestId: number): Observable<any> {
    return this.httpClient
      .put(this.getApiURI() + `/facilityandmaintenance/${requestId}/approve-register-hazard-materials-tenant`, {})
      .catch(this.handleError)
  }
  confirmRegisterHazardMaterialRequest(requestId: number): Observable<any> {
    return this.httpClient
      .put(this.getApiURI() + `/facilityandmaintenance/${requestId}/confirm-registered-materials`, {})
      .catch(this.handleError)
  }

  rejectGeneralRequestByTenant(requestId: number, comments: string): Observable<any> {
    return this.httpClient
      .put(this.uri + `${requestId}/reject-fm-tenant`, { comments: comments })
      .catch(this.handleError)
  }
  updateRegisteredHazMaterial(requestId: number, quantityInStock: number): Observable<any> {
    return this.httpClient
      .put(this.uri + `${requestId}/update-registered-material`, { quantityInStock: quantityInStock })
      .catch(this.handleError)
  }
  approveGeneralRequestByQSTPFM(requestId: number): Observable<any> {
    return this.httpClient
      .put(this.getApiURI() + `/facilityandmaintenance/${requestId}/approve-fm-QSTPFM`, {})
      .catch(this.handleError)
  }
  addChargesRequestByQSTPFM(requestId: number, FMRequestCharge: number, comments: string): Observable<any> {
    return this.httpClient
      .put(this.getApiURI() + `/facilityandmaintenance/${requestId}/add-request-charges`, { FMRequestCharge: FMRequestCharge, comments: comments })
      .catch(this.handleError)
  }

  addRequestClassification(requestId: number, RequestClassification: number): Observable<any> {
    return this.httpClient
      .put(this.getApiURI() + `/facilityandmaintenance/${requestId}/add-fm-request-severity`, { RequestClassification: RequestClassification })
      .catch(this.handleError)
  }
  confirmChargesRequestByQSTPFM(requestId: number, chargeConfirmation: boolean): Observable<any> {
    return this.httpClient
      .put(this.getApiURI() + `/facilityandmaintenance/${requestId}/confirm-request-charges`, { chargeConfirmation: chargeConfirmation })
      .catch(this.handleError)
  }

  rejectGeneralRequestByQSTPFM(requestId: number, comments: string): Observable<any> {
    return this.httpClient
      .put(this.uri + `${requestId}/reject-fm-QSTPFM`, { comments: comments })
      .catch(this.handleError)
  }

  getMaterialFiles(id: number): Observable<MaterialFile[]> {
    return this.httpClient
      .get(this.uri + `${id}/files`)
      .catch(this.handleError);
  }

  getFMRequestMaterials(requestId: number, requestType: number): Observable<FMRequestHazardMaterial[]> {
    return this.http
      .post(this.getApiURI() + '/facilityandmaintenance/GetRequestMaterial', JSON.stringify({ requestId: requestId,requestType :requestType }))
      .catch(this.handleError)
  }

  approveDelieryRequestByQSTPSecurity(requestId: number): Observable<any> {
    return this.httpClient
      .put(this.getApiURI() + `/facilityandmaintenance/${requestId}/approve-delivery-request-security`, {})
      .catch(this.handleError)
  }
  rejectDelieryRequestByQSTPSecurity(requestId: number, comments: string): Observable<any> {
    return this.httpClient
      .put(this.uri + `${requestId}/reject-delivery-request-security`, { comments: comments })
      .catch(this.handleError)
  }
  getFMREquestMaterials(requestId: number): Observable<FMRequestHazardMaterial[]> {
    return this.http
      .post(this.getApiURI() + '/facilityandmaintenance/GetRequestMaterial', JSON.stringify({ requestId }))
      .catch(this.handleError)
  }

  makeInProgressRequestByTenant(requestId: number, RequestClassification: number, RequestCompeletionDate: Date, CAFMRequestNumber: string): Observable<any> {
    return this.httpClient
      .put(this.getApiURI() + `/facilityandmaintenance/${requestId}/make-in-progress-fm-QSTPFM`, { RequestClassification: RequestClassification, RequestCompeletionDate: RequestCompeletionDate, CAFMRequestNumber: CAFMRequestNumber})
      .catch(this.handleError)
  }
  reOpenByTsd(requestId: number, comments: string): Observable<any> {
    return this.httpClient
      .put(this.uri + `${requestId}/reopen-by-tsd`, { comments: comments })
      .catch(this.handleError)
  }
  recordStatusUpdates(requestId: number, comments: string): Observable<any> {
    return this.httpClient
      .put(this.uri + `${requestId}/record-status-updates`, { comments: comments })
      .catch(this.handleError)
  }
}



// WEBPACK FOOTER //
// ./src/app/core/data/fm.service.ts